import { render, staticRenderFns } from "./addStaffCollectedProduct.vue?vue&type=template&id=17bb7f1b&scoped=true"
import script from "./addStaffCollectedProduct.vue?vue&type=script&lang=js"
export * from "./addStaffCollectedProduct.vue?vue&type=script&lang=js"
import style0 from "./addStaffCollectedProduct.vue?vue&type=style&index=0&id=17bb7f1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bb7f1b",
  null
  
)

export default component.exports